import { render, staticRenderFns } from "./TouGe.vue?vue&type=template&id=0ef41482&scoped=true"
import script from "./TouGe.vue?vue&type=script&lang=js"
export * from "./TouGe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef41482",
  null
  
)

export default component.exports